/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Line } from "./modelLine";

class ControllerLine extends ControllerModel {
  constructor() {
    super("ControllerLine");
    
    this.setNewNode = (callback, location) => {
      let line = new Line(location);
      line.decorate(callback);
      this.addNode(line)
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let line = new Line();
      line.copyFrom(node);
      line.decorate(callback);
      this.addNode(line);
    }

    this.getProperties = async (node) => {
      let n = new Line();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Line();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerLine };
